import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { motion } from 'framer-motion';

export const Card = ({ children, className = "", noPadding = false }) => (
  <motion.div 
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    className={`glass-panel rounded-xl border border-navy-600 overflow-hidden ${noPadding ? '' : 'p-5'} ${className}`}
  >
    {children}
  </motion.div>
);

export const Badge = ({ children, type = "default", className = "" }) => {
  const styles = {
    default: "bg-navy-700 text-slate-300 border-navy-600",
    success: "bg-green-500/10 text-green-400 border-green-500/30",
    warning: "bg-orange-500/10 text-orange-400 border-orange-500/30",
    danger: "bg-alert-500/10 text-alert-500 border-alert-500/30",
    info: "bg-cyan-500/10 text-cyan-400 border-cyan-500/30",
  };
  
  return (
    <span className={`px-2.5 py-1 text-xs font-medium rounded-full border ${styles[type]} ${className}`}>
      {children}
    </span>
  );
};

export const Button = ({ children, variant = "primary", icon, onClick, className = "" }) => {
  const baseStyle = "inline-flex items-center justify-center gap-2 px-4 py-2 text-sm font-medium rounded-lg transition-all duration-200";
  const variants = {
    primary: "bg-orange-500 hover:bg-orange-400 text-white shadow-[0_0_10px_rgba(255,90,0,0.3)] hover:shadow-[0_0_15px_rgba(255,90,0,0.5)] border border-orange-400",
    secondary: "bg-navy-700 hover:bg-navy-600 text-slate-200 border border-navy-600",
    outline: "bg-transparent hover:bg-navy-700 text-cyan-400 border border-cyan-500/50",
    danger: "bg-alert-500/20 hover:bg-alert-500/30 text-alert-500 border border-alert-500/50",
  };

  return (
    <button onClick={onClick} className={`${baseStyle} ${variants[variant]} ${className}`}>
      {icon && <SafeIcon icon={icon} />}
      {children}
    </button>
  );
};

export const ProgressBar = ({ progress, colorClass = "bg-green-500" }) => (
  <div className="w-full bg-navy-900 rounded-full h-1.5 border border-navy-700 overflow-hidden">
    <div className={`${colorClass} h-1.5 rounded-full relative`} style={{ width: `${progress}%` }}>
      <div className="absolute top-0 right-0 bottom-0 left-0 bg-white/20 animate-pulse"></div>
    </div>
  </div>
);